/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:56
 * @LastEditTime: 2021-08-19 09:52:54
 * @Description: 
 */
import axios from "axios";
import logger from "./logger";
import data from '../services/data'
const source = axios.CancelToken.source;

//请求拦截器
axios.interceptors.request.use(
  (config) => {
    logger.httpLog("发送请求：", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    logger.httpLog("后端响应：", res);
    return res;
  },
  (error) => {
    // 如果token过期，重新登录
    if(error.response.data.code === 9) {
      // 跳转到登录页面
      // data.removeAuthorization()
      // data.removeToken()
      // sessionStorage.removeItem('user')
      return Promise.reject(new Error('token过期，请重新登录！'));
    }
    logger.httpLog(
      "请求出错",
      error,
      error.response,
      error.response && error.response.status
    );
    return Promise.reject(error);
  }
);

/**
 * http get
 * @param {String} url
 * @param {Object} params 一个简单对象 或者 一个 URLSearchParams对象
 * @param {Object} config headers等配置
 */
export function get(url, params = {}, config = {}) {
  const axiosConfig = { params, ...config };
  return axios.get(url, axiosConfig).then((res) => {
    return res.data || {};
  });
}

/**
 *
 * @param {String} url
 * @param {*} data
 * @param {Object} config
 */
export function post(url, data = {}, config = {}) {
  return axios.post(url, data, config).then((res) => {
    return res.data || {};
  });
}

/**
 * http delete
 * @param {String} url
 * @param {Object} config headers等配置
 */
export function httpDelete(url, config = {}) {
  const axiosConfig = { ...config };
  return axios.delete(url, axiosConfig).then((res) => {
    return res.data || {};
  });
}

/**
 *  http put
 * @param {String} url
 * @param {*} data
 * @param {Object} config
 */
export function put(url, data = {}, config = {}) {
  return axios.put(url, data, config).then((res) => {
    return res.data || {};
  });
}

const http = {
  get,
  post,
  httpDelete,
  put,
  source
};

export default http;
